import {
  ActiveOrganization,
  useCustomerAccountPortal,
  useHasCustomerAccount
} from "@/api";
import { Button } from "@/components/ui/button";
import { LoadingCircle } from "@/components/ui/loadingCircle";
import { cn } from "@/lib/utils";
import { CheckCircle2, ExternalLink } from "lucide-react";

type Props = {
  organization: ActiveOrganization;
};

export const CustomerAccount = ({ organization }: Props) => {
  const { data, loading: loadingCustomerAccount } = useHasCustomerAccount({
    organizationSlug: organization.slug
  });

  const { openCustomerAccountPortal, loading: loadingCustomerPortalLink } =
    useCustomerAccountPortal({ organization });

  const loading = loadingCustomerPortalLink || loadingCustomerAccount;
  const hasCustomerAccount =
    data?.organization.__typename === "Organization" &&
    data.organization.hasCustomerAccount;

  if (loading) return <LoadingCircle />;

  return (
    <div className="flex items-center gap-2">
      {hasCustomerAccount && <CheckCircle2 className="text-green-400" />}
      <Button
        variant={hasCustomerAccount ? "outline" : "default"}
        onClick={openCustomerAccountPortal}
        className={cn(!hasCustomerAccount && "min-w-60")}
        data-testid="customer-portal-button"
      >
        {hasCustomerAccount ? "Customer portal" : "Connect customer account"}
        <ExternalLink size={14} className="ml-4" />
      </Button>
    </div>
  );
};
